import { AppThunkAction } from '../reducers';

import * as Services from '../../services/Snomed.Services';
import * as Actions from '../actions';
import * as ActionEvents from '../actions/Snomed.Actions';
import { ErrorType } from '../../models/HttpError';

export type KnownAction =
    | Actions.Snomed.SnomedSearchRequestAction
    | Actions.Snomed.SnomedSearchSuccessAction
    | Actions.Snomed.SnomedSearchFailureAction
    | Actions.Snomed.SnomedSearchClearAction;

export const actionCreators = {
    SearchSnomedSpecialties: (searchTerm: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({
                type: ActionEvents.SNOMED_SEARCH_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        }

        dispatch({
            type: ActionEvents.SNOMED_SEARCH_REQUEST,
            searchTerm
        });

        Services.SearchSnomedSpecialties(token, searchTerm)
            .then((response) => {
                dispatch({
                    type: ActionEvents.SNOMED_SEARCH_SUCCESS,
                    payload: response,
                    searchTerm
                });
            })
            .catch((error: ErrorType) => {
                dispatch({
                    type: ActionEvents.SNOMED_SEARCH_FAILURE,
                    error
                });
            });
    },

    ClearSnomedSearch: (): AppThunkAction<KnownAction> => async (dispatch) => {
        dispatch({ type: ActionEvents.SNOMED_SEARCH_CLEAR });
    }
};
